import script from "./InformacoesAmbientaisForm_21.vue?vue&type=script&setup=true&lang=js"
export * from "./InformacoesAmbientaisForm_21.vue?vue&type=script&setup=true&lang=js"

import "./InformacoesAmbientaisForm_21.vue?vue&type=style&index=0&id=3ec30970&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3ec30970"]])

export default __exports__